import moment from 'moment';
import 'moment/locale/si';

const Utility = {

    getAPIPayLoadForAddHc(hcDataInput) {
        var dateTimeLocal = moment({ y: hcDataInput.year.id, M: hcDataInput.month.Id, d: hcDataInput.date.id, h: hcDataInput.hour.id, m: hcDataInput.minute.id, s: 0 });
        dateTimeLocal.locale('si');
        var dateTimeLocalString = dateTimeLocal.format("YYYY, MMMM Do dddd, a h:mm");
        var subId = localStorage.getItem('UseActiveAccount');
        const hcDataInputAPI = {
            SubId: subId,
            Year: hcDataInput.year.id,
            Month: hcDataInput.month.Id + 1,// back end months start from 1(not 0)
            Date: hcDataInput.date.id,
            Hour: hcDataInput.hour.id,
            Minute: hcDataInput.minute.id,
            Second: 0, 
            CountryCode: hcDataInput.country.code,
            CountryName: hcDataInput.country.label,
            TownName: hcDataInput.location.location.label,
            Longituede: hcDataInput.location.locationGeoData.lng,
            LongituedeDecimal: hcDataInput.location.locationGeoData.lng,
            LongitudeDirection: hcDataInput.location.locationGeoData.lng >= 0 ? "E" : "W",
            Latitude: hcDataInput.location.locationGeoData.lat,
            LatitudeDecimal: hcDataInput.location.locationGeoData.lat,
            LatitudeDirection: hcDataInput.location.locationGeoData.lat >= 0 ? "N" : "S",
            TimeZoneHours: Math.floor(hcDataInput.location.locationTimeZone.rawOffset / 3600),
            TimeZoneMinutes: (hcDataInput.location.locationTimeZone.rawOffset % 3600) / 60,
            DayLightSavingHours: Math.floor(hcDataInput.location.locationTimeZone.dstOffset / 3600),
            DaylightSavingMinutes: (hcDataInput.location.locationTimeZone.dstOffset % 3600) / 60,
            MaleOrFemale: hcDataInput.gender,
            Location: hcDataInput.location.location.label,
            DateTimeLocalString: dateTimeLocalString, 
            Name: hcDataInput.name, 
            PlaceId: hcDataInput.location.location.place_id
        }
        return hcDataInputAPI;
    },

    getPlanetSymbol(sinhalaName) {
        const planetMap = {
            'රවී': '&#9788;',  // Sun ☉
            'චන්ද්‍ර': '&#9789;',  // Moon ☽
            'බුධ': '&#9791;',     // Mercury ☿
            'ශුක්‍ර': '&#9792;',   // Venus ♀
            'ගුරු': '&#9794;',  // Mars ♂
            'කුජ': '&#9795;', // Jupiter ♃
            'ශනි': '&#9796;',     // Saturn ♄
            'යුරේනස්': '&#9797;',    // Uranus ♅
            'නෙප්චූන්': '&#9798;', // Neptune ♆
            'ප්ලූටෝ': '&#9799;',    // Pluto ♇
            'පෘථිවිය': '&#8853;',     // Earth ⊕
            'රාහු': '&#9738;', // Rahu ☊
            'කේතු': '&#9739;' // Ketu ☋
        };
        return planetMap[sinhalaName] || '';
    }
}



export default Utility;